import React, { useEffect } from "react"
import { NumberTagFieldSeeker } from "@ui-seeker/core"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useCsv } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { isEmpty } from "@ui-seeker/utils"


export default function NextFullMonthField() {

	const {
		nextFullMonth,
		setNextFullMonthInfo,
		error
	} = useReportFormInfo(
		reportFormData.peek().nextFullMonth,
		"nextFullMonth",
		object({
			nextFullMonth: array()
				.required("Must provide a positive month number")
				.test("min", "Must provide a positive month number", () => !!nextFullMonth.length && nextFullMonth.every(e => +e >= 0))
		}))

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setNextFullMonthInfo([], false)
		}
	}, [useCsv.value])

	return <NumberTagFieldSeeker
		value={nextFullMonth || []}
		onChange={e => setNextFullMonthInfo(e)}
		error={error}
		label="Next full month"
		placeholder="0 for actual month"
	/>
}